import { render, staticRenderFns } from "./ListHeader.vue?vue&type=template&id=2466230b&scoped=true"
import script from "./ListHeader.vue?vue&type=script&lang=js"
export * from "./ListHeader.vue?vue&type=script&lang=js"
import style0 from "./ListHeader.vue?vue&type=style&index=0&id=2466230b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2466230b",
  null
  
)

export default component.exports